module.exports = __webpack_public_path__ + "img/error.2db0af46.svg";